import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactForm = ({ lenguaje }) => {
  const [showResult, setShowResult] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "tomassarmiento",
        "template_exkoace",
        e.target,
        "user_mfwX0ZBVKpIfn2psNZn28"
      )
      .then(
        (result) => {
          console.log(result.text);
          setShowResult("ok");
        },
        (error) => {
          console.log(error.text);
          setShowResult("error");
        }
      );
    document.querySelector(".contact-form").style.setProperty("--opacity", 0);
    document.querySelector(".contact-form").style.setProperty("--index", -10);
    setTimeout((showResult) => setShowResult(""), 7000);
    e.target.reset();
  };

  if (showResult === "ok") {
    return (
      <>
        <h2 style={{ color: "green" }}>Message successfully sent!</h2>
        <label for="">
          <div className="check-icon"></div>
        </label>
      </>
    );
  }

  if (showResult === "error") {
    return (
      <>
        <h2 style={{ color: "red" }}>An error ocurred, sorry</h2>
      </>
    );
  }

  return (
    <>
      <h2>{lenguaje == "eng" ? "Send a message" : "Envíeme un mensaje"}</h2>
      <form className="contact-form" onSubmit={(e) => sendEmail(e)}>
        <div className="inputBox w50">
          <input type="text" name="firstName" required />
          <span>{lenguaje == "eng" ? "First Name" : "Nombre"}</span>
        </div>
        <div className="inputBox w50">
          <input type="text" name="lastName" required />
          <span>{lenguaje == "eng" ? "Last Name" : "Apellido"}</span>
        </div>
        <div className="inputBox w50">
          <input type="email" name="email" required />
          <span>Email</span>
        </div>
        <div className="inputBox w50">
          <input type="text" name="phone" required />
          <span>
            {lenguaje == "eng" ? "Mobile Number" : "Número de Teléfono"}
          </span>
        </div>
        <div className="inputBox w100">
          <textarea name="message" required></textarea>
          <span>
            {lenguaje == "eng"
              ? "Write your message here..."
              : "Escriba su mensaje aquí..."}
          </span>
        </div>
        <div className="inputBox w100">
          <input type="submit" value={lenguaje == "eng" ? "Send" : "Enviar"} />
        </div>
      </form>
    </>
  );
};

export default ContactForm;
